'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../input/style');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/pagination/style/index.js
// module id = 419
// module chunks = 0